import { computed } from 'mobx';
import type { AssetId } from 'owa-timestream-types';
import { getSelectedProjectId, getRenderingOrder, getLastKnownBounds } from 'owa-timestream-store';
import { getProjectPreviewId } from 'owa-timestream-projectmanager';
import getOverlappingAssets from './getOverlappingAssets';

const OVERLAP_FORGIVENESS = 20;

const overlappedAssets = computed(() => {
    const projectId = getProjectPreviewId() ?? getSelectedProjectId();
    const renderingOrder = getRenderingOrder(projectId);
    return renderingOrder.reduce((allOverlappedAssets, currAssetId) => {
        const currAssetBounds = getLastKnownBounds(projectId, currAssetId);
        const shouldProcessAsset = (assetId: AssetId) => {
            return assetId !== currAssetId;
        };
        if (currAssetBounds) {
            const overlaps = getOverlappingAssets(
                currAssetBounds,
                -OVERLAP_FORGIVENESS,
                shouldProcessAsset
            );
            overlaps.forEach(overlappingAssetId => {
                allOverlappedAssets.add(currAssetId);
                allOverlappedAssets.add(overlappingAssetId);
            });
        }
        return allOverlappedAssets;
    }, new Set<AssetId>());
});

export default function isAssetOverlapped(assetId: AssetId): boolean {
    return overlappedAssets.get().has(assetId);
}
